// extracted by mini-css-extract-plugin
export default {"wrapper":"LandingPage_wrapper__TUhRB","logo":"LandingPage_logo__LA42b","collection":"LandingPage_collection__gvqHz","game":"LandingPage_game__0fvun"};